import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts';
import FormUploadstockMerchant from '../../components/forms/FormUploadstockMerchant';
import { Card } from '@mantine/core';
import styles from './styles.scoped.css';
import { useDispatch, useSelector } from 'react-redux';
import { uploadStockMerchant } from './actions';
import { useNavigate } from 'react-router-dom';
import { fetchSessionProtection } from '../../components/layouts/PageBase/actions';

export default function UploadStockMerchant(){
  const { setBreadcrumbs } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [afterSubmit, setAfterSubmit] = useState(false);
  const {
    dataUploadStock, isLoadingUploadStock, messageUploadStock
  } = useSelector((state) => state.updateStockMerchant);

  useEffect(() => {
    dispatch(fetchSessionProtection());
    setBreadcrumbs([
      { name: 'Update Stok Pangkalan', to: '/merchant/update-stock-merchant' },
      'Unggah Data Stok Pangkalan'
    ]);
  }, []);

  useEffect(() => {
    if(afterSubmit && !isLoadingUploadStock && dataUploadStock?.success){
      navigate('/merchant/update-stock-merchant');
    }
  }, [isLoadingUploadStock, messageUploadStock, dataUploadStock]);

  const handleSubmit = (data) => {
    if (isLoadingUploadStock) {
      return;
    }

    dispatch(uploadStockMerchant(data));
    setAfterSubmit(true);
  };

  return(
    <div className={styles.container}>
      <Card className={styles.card} radius={'md'}>
        <FormUploadstockMerchant isLoading={isLoadingUploadStock} onSubmit={handleSubmit}/>
      </Card>
    </div>
  );
}
